export const EditCommentActionTypes = {
    OPEN_EDIT_COMMENT_PAGE: 'OPEN_EDIT_COMMENT_PAGE',
    CLOSE_EDIT_COMMENT_PAGE: 'CLOSE_EDIT_COMMENT_PAGE'
};